const MAX_RECENT = 8;

/**
 * Persist a recently selected app for trigger or action pickers.
 * @param {object} appObj
 * @param {'action'|'trigger'} type
 */
export function saveRecentApp(appObj, type = 'action') {
  if (!appObj?.name && !appObj?.app) return;
  const storageKey = `recentApps_${type}`;
  let recentApps = [];
  try {
    const stored = localStorage.getItem(storageKey);
    if (stored) recentApps = JSON.parse(stored);
  } catch (e) {
    console.error('Error reading recent apps:', e);
  }

  recentApps = recentApps.filter((item) => item.name !== appObj.name && item.app !== appObj.app);
  recentApps.unshift({
    name: appObj.name,
    app: appObj.app,
    icon: appObj.icon,
    auth: appObj.auth,
    custombutton: appObj.custombutton,
    formDataEndpoint: appObj.formDataEndpoint,
    category: appObj.category,
    trigger: appObj.trigger,
    action: appObj.action,
  });
  recentApps = recentApps.slice(0, MAX_RECENT);

  try {
    localStorage.setItem(storageKey, JSON.stringify(recentApps));
  } catch (e) {
    console.error('Error saving recent apps:', e);
  }
}

/**
 * @param {'action'|'trigger'} type
 * @returns {object[]}
 */
export function getRecentApps(type = 'action') {
  const storageKey = `recentApps_${type}`;
  try {
    const stored = localStorage.getItem(storageKey);
    if (stored) return JSON.parse(stored);
  } catch (e) {
    console.error('Error reading recent apps:', e);
  }
  return [];
}

/** Utility / built-in action tools (no third-party auth). */
export function isUtilityApp(app) {
  return app?.category === 'Utility' && app?.trigger === false && app?.auth === false;
}
